import React, { Component } from 'react';

import {
    loadCategories,
    loadProducts,
    loadQuestions,
    loadAnswers,
    loadDependsOnQuestions
} from '../../../actions';
import {
    MENU_ITEM_TYPE_MENU,
    MENU_ITEM_TYPE_CATEGORY,
    MENU_ITEM_TYPE_PRODUCT,
    MENU_ITEM_TYPE_QUESTION,
    MENU_ITEM_TYPE_ANSWER,
    MENU_ITEM_SUB_QUESTION,
    MENU_ITEM_SUB_ANSWER
} from '../../../utils/Constants';
import { capitalizeFirstLetter } from '../../../utils/CommonUtils';

class BaseMenuItemScreen extends Component {
    getInitialBaseState() {
        return {
            selectedMenu: {},
            selectedMenuDraftId: -1,
            selectedCategory: {},
            selectedCategoryDraftId: -1,
            selectedProduct: {},
            selectedProductDraftId: -1,
            selectedQuestion: {},
            selectedQuestionDraftId: -1,
            selectedAnswer: {},
            selectedSubQuestionDraftId: -1,
            selectedSubQuestion: {},
            selectedSubAnswer: {},
            activeMenu: {},
            activeCategory: {},
            activeProduct: {},
            activeQuestion: {},
            activeAnswer: {},
            activeSubQuestion: {},
            activeSubAnswer: {}
        };
    }

    loadColumnsData(selectedColumnData, saveOrPublish, column, doNotCallQuestions, restaurantId, excludeMealDeal, saveInMenuProductCategoryReducer) {
        const { loadCategories, loadProducts, loadQuestions, loadAnswers } = this.props;
        let draftId = selectedColumnData.id;
        let nextColumn;

        switch (column) {
            case MENU_ITEM_TYPE_MENU:
                loadCategories(draftId, excludeMealDeal, saveInMenuProductCategoryReducer);
                nextColumn = MENU_ITEM_TYPE_CATEGORY;
                break;
            case MENU_ITEM_TYPE_CATEGORY:
                loadProducts(draftId, saveInMenuProductCategoryReducer);
                nextColumn = MENU_ITEM_TYPE_PRODUCT;
                break;
            case MENU_ITEM_TYPE_PRODUCT:
                if (doNotCallQuestions) break;
                loadQuestions(draftId);
                nextColumn = MENU_ITEM_TYPE_QUESTION;
                break;
            case MENU_ITEM_TYPE_QUESTION:
                loadAnswers(draftId);
                nextColumn = MENU_ITEM_TYPE_ANSWER;
                break;
            case MENU_ITEM_TYPE_ANSWER:
                if (selectedColumnData.mealDealProduct) {
                    loadQuestions(draftId, selectedColumnData.mealDealProduct, selectedColumnData.posId, restaurantId);
                    nextColumn = MENU_ITEM_SUB_QUESTION;
                    break;
                } else {
                    this.selectCurrentAnswer(selectedColumnData);
                    return;
                }
            case MENU_ITEM_SUB_QUESTION:
                loadAnswers(draftId, MENU_ITEM_SUB_QUESTION);
                nextColumn = MENU_ITEM_SUB_ANSWER;
                break;
            case MENU_ITEM_SUB_ANSWER:
                this.selectCurrentSubAnswer(selectedColumnData);
                return;
        }

        if (saveOrPublish) {
            this.setState({
                [`selected${capitalizeFirstLetter(column)}`]: selectedColumnData,
                [`selected${capitalizeFirstLetter(column)}DraftId`]: draftId,
                [`active${capitalizeFirstLetter(column)}`]: {},
                [`active${capitalizeFirstLetter(nextColumn)}`]: {}
            });
        } else {
            this.setState({
                [`selected${capitalizeFirstLetter(column)}`]: selectedColumnData,
                [`selected${capitalizeFirstLetter(column)}DraftId`]: draftId,
                [`active${capitalizeFirstLetter(column)}`]: selectedColumnData,
                [`active${capitalizeFirstLetter(nextColumn)}`]: {}
            });
        }
    }

    selectCurrentAnswer(answer) {
        this.setState({
            activeAnswer: answer
        });
    }

    selectCurrentSubAnswer(subAnswer) {
        this.setState({
            activeSubAnswer: subAnswer
        });
    }
}

export default BaseMenuItemScreen;


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/BaseMenuItemScreen.js